module.exports = __webpack_public_path__ + "img/1547084473.141fdf2c.jpg";